export const CONFIGURAR_TOKEN = 'CONFIGURAR_TOKEN';